module.exports = __webpack_public_path__ + "img/edit-alt-3.9a8ebef1.svg";